import { IconCheck } from 'featherico';
import Button from '../../../../../components/Button';
import ButtonContainer from '../../../../../components/ButtonContainer';
import UiPopover from '../../../../../components/UiPopover';
import r from '../../../../../services/Replacement';
import styles from './style.m.less';

interface Props {
    onDismiss: () => void;
}

export function AutomationsSparkContent({ onDismiss }: Props): JSX.Element {
    return (
        <UiPopover direction="top--right">
            <div className={styles.sparkContent}>
                <div>
                    <h4>Automations has moved 🚛</h4>
                </div>
                <div>
                    You can now create and manage feedback automations from the Automations tab in the {r('anyfb.name')}{' '}
                    screen.
                </div>
                <ButtonContainer>
                    <Button kind="PRIMARY" isSmall={true} onClick={onDismiss} autoFocus>
                        Got it <IconCheck />
                    </Button>
                </ButtonContainer>
            </div>
        </UiPopover>
    );
}
